<template>
    <ProductThumb :product="product" :small="true" :effect="effect" body-class="text-center" :show-premium="false" @product-clicked="emit('product-clicked')">
        <p
            class="card-text mb-2"
            :class="{
                'text-danger': product.is_special,
                'invisible': !(product.gross_price > 0)
              }"
        >
            <span v-if="product.shop_availability && product.gross_price > 0">
                {{ $formatter.price(product.gross_price) }}
              </span>
            <span v-else>&nbsp;</span>
        </p>
    </ProductThumb>
</template>

<script setup lang="ts">
const ProductThumb = defineAsyncComponent(() => import("~/components/Product/Thumbs/ProductThumb.vue"));

withDefaults(defineProps<{
    product: Record<string, any>;
    effect?: boolean;
}>(), {
    effect: true,
});

const emit = defineEmits(['product-clicked']);
</script>
